import { stopPropagation } from '../../utils/events'

import {
  QA_NAME_ENTITY_EXTRA_TAGS_DOC_FLOW,
  QA_NAME_ENTITY_EXTRA_TAGS_EMAIL,
  QA_NAME_ENTITY_EXTRA_TAGS_FILES,
  QA_NAME_ENTITY_EXTRA_TAGS_RELATED,
} from './EntityExtraTags.constants'

function getEntityExtraTagsTagHandler({ handlers, tagId }) {
  switch (tagId) {
    case QA_NAME_ENTITY_EXTRA_TAGS_FILES:
      return handlers.onClickFileTag
    case QA_NAME_ENTITY_EXTRA_TAGS_EMAIL:
      return handlers.onClickEmailTag
    case QA_NAME_ENTITY_EXTRA_TAGS_RELATED:
      return handlers.onClickRequestTag
    case QA_NAME_ENTITY_EXTRA_TAGS_DOC_FLOW:
      return handlers.onClickDocFlowTag
    default:
      return null
  }
}

export function getEntityExtraTagsClickHandler({
  directoryId,
  handlers,
  itemId,
  objectId,
  tagId,
}) {
  const handler = getEntityExtraTagsTagHandler({ handlers, tagId })

  return handler
    ? event => {
        stopPropagation(event)

        handler({ directoryId, itemId, objectId })
      }
    : null
}
